"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
/*
	intro : mult sync process defination
	Author : chenchao
	Date : 2019-07-02
*/


var _reactPureCheck = require("react-pure-check");

var _log = require("./log");

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var MultSync = function () {
  function MultSync() {
    _classCallCheck(this, MultSync);

    this.processOffset = 0;
    this.processArr = [];
    this.arg = [];
    this.arguments = null;
  }

  _createClass(MultSync, [{
    key: "use",
    value: function use() {
      var processName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if ((0, _reactPureCheck.Types)(processName) !== "function") {
        (0, _log.errorLog)("you should offer a %s for processName", "string");
        return false;
      }

      this.processArr.push(processName);
    } // run process

  }, {
    key: "runProcess",
    value: function runProcess(offset) {
      var _processArr;

      if (this.processArr.length - 1 < offset) return false;

      (_processArr = this.processArr)[offset].apply(_processArr, _toConsumableArray(this.arg));
    } // run next function

  }, {
    key: "next",
    value: function next() {
      // run function
      this.runProcess(++this.processOffset);
    } // emit run first function

  }, {
    key: "emit",
    value: function emit() {
      if ((0, _reactPureCheck.Types)(this.processArr[this.processOffset]) !== "function") {
        (0, _log.errorLog)("please run use function to register process first");
        return false;
      } // init offset


      this.processOffset = 0;

      for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {
        arg[_key] = arguments[_key];
      }

      this.arg = [].concat(arg); // run function

      this.runProcess(0);
    }
  }]);

  return MultSync;
}();

;
exports.default = MultSync;